import { createFileRoute } from "@tanstack/react-router";
import AdminTermNewPage from "@/pages/admin/terms/new";
import { useTermsPermissions } from "@/pages/admin/terms";

export const Route = createFileRoute("/app/admin/terms/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllTerms, userCanViewAllTerms } = useTermsPermissions();

  return (
    <AdminTermNewPage
      userCanEditAllTerms={userCanEditAllTerms}
      userCanViewAllTerms={userCanViewAllTerms}
    />
  );
}
